import React, { useState } from "react";
import {
  TextTheme,
  UI_ModuleTextDownCard,
  UI_ModuleTitleCard,
} from "../../../../../../UI_ITO/indexUI";
import { DeleteOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import { IndividualCardInfo } from "./IndividualCardInfo/IndividualCardInfo";
import { useParams } from "react-router-dom";
import { useDeleteMemberFlMutation } from "../../../../../../store/api/applicationBankApi/individual.api";
import { IIndividualCardProps } from "../../../../../../interfaces/props/IIndividualCardProps";

import classes from "./IndividualCard.module.css";

export function IndividualCard(props: IIndividualCardProps) {
  const { name, isOpen, percent, isRequiredFields } = props;
  const [collapseIsOpen, setCollapseIsOpen] = useState(isOpen ?? false);
  const { applicationBankId, applicationId } = useParams();
  const [deleteMemberFl] = useDeleteMemberFlMutation();

  function handleCollapse() {
    return setCollapseIsOpen((prev) => !prev);
  }

  function deleteIndividual() {
    if (applicationBankId && props.id) {
      deleteMemberFl({
        applicationBankId: Number(applicationBankId),
        applicationId: Number(applicationId),
        fl_id: props.id,
      });
    }
  }

  return (
    <div>
      <UI_ModuleTitleCard
        title={name}
        icon={
          collapseIsOpen ? (
            <UpOutlined onClick={handleCollapse} />
          ) : (
            <DownOutlined onClick={handleCollapse} />
          )
        }
        iconAdditional={
          <DeleteOutlined style={{ color: "red" }} onClick={deleteIndividual} />
        }
        className={`${classes.individualCard} ${collapseIsOpen ? classes.open : ""}`}
        textDown={
          <>
            {!isRequiredFields && (
              <UI_ModuleTextDownCard
                theme={TextTheme.ERROR}
                textDown={[`Заполните все поля чтобы сохранить учредителя`]}
              />
            )}
            {percent && (
              <UI_ModuleTextDownCard
                textDown={[`Доля УК физического лица ${percent}%`]}
              />
            )}
          </>
        }
      />
      {collapseIsOpen && (
        <IndividualCardInfo {...props} openOrCloseForm={handleCollapse} />
      )}
    </div>
  );
}
